import { Stack, Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { ITitle } from "src/types/global";
const TitlePage = ({
  title,
  subtitle
}: ITitle) => {
  return <Stack direction={"row"}>
      <Box>
        <Typography variant="h5" fontWeight={700} marginBottom={1}>
          {title}
        </Typography>
        <Typography color={grey[600]}>{subtitle}</Typography>
      </Box>
    </Stack>;
};
export default TitlePage;